import React, {Component} from 'react';
import {NavLink} from "react-router-dom"
import {ReactSVG} from "react-svg";
import {app} from "app/app";
import {images} from 'assets/img/dashboard/layout/sidebar';
import 'assets/sass/dashboard/layout/Sidebar.scss';

export class Sidebar extends Component {
    render() {
        const allRoutes = app.routes();

        return (
            <aside className="dashboard-sidebar">
                <NavLink to={allRoutes.dashboard.home} exact className="dashboard-sidebar--item">
                    <figure className="item-icon">
                        <ReactSVG src={images.wallet}/>
                    </figure>
                    <div className="item-label">Billetera</div>
                </NavLink>
                <div className="dashboard-sidebar--subitems">
                    <NavLink to={allRoutes.dashboard.buyAndSell.homeBuy} className="item">
                        <div>Comprar</div>
                    </NavLink>
                    <NavLink to={allRoutes.dashboard.buyAndSell.homeSell} className="item">
                        <div>Vender</div>
                    </NavLink>
                    <NavLink to={allRoutes.dashboard.depositAndWithdraw.homeWithdraw} className="item">
                        <div>Retirar</div>
                    </NavLink>
                    <NavLink to={allRoutes.dashboard.depositAndWithdraw.homeDeposit} className="item">
                        <div>Ingresar</div>
                    </NavLink>
                </div>
                <NavLink exact to={allRoutes.dashboard.invest} className="dashboard-sidebar--item">
                    <figure className="item-icon">
                        <ReactSVG src={images.investment}/>
                    </figure>
                    <div className="item-label">Mis inversiones</div>
                </NavLink>
            </aside>
        );
    }
}
